module.exports = __webpack_public_path__ + "static/media/5f36b2e5-b93d-4c41-bab2-d94f1b884bf9.2ff53b7b.jpg";